import type { Trip } from '@bambi/api-client/schemas';

export function shouldSeparateCancelReasonValueAndLabel(trip?: Trip) {
  /**
   * Return true when cancellation should pass the reason value and label
   * separately.
   */
  const intermediaries = ['modivcare', 'medidrive'];

  if (!trip?.id) {
    return false;
  }

  return intermediaries.includes(trip.intermediary ?? '');
}

export function shouldSeparateRejectReasonValueAndLabel(trip?: Trip) {
  /**
   * Return true when rejection should pass the reason value and label
   * separately.
   */
  const intermediaries = ['modivcare'];

  if (!trip?.id) {
    return false;
  }

  return intermediaries.includes(trip.intermediary ?? '');
}
